module.exports = __webpack_public_path__ + "media/images/flags/4x3/idn-24dc86d935e39127ccdb5b416c047704.svg";